<mat-form-field class="w-[180px]" subscriptSizing="dynamic">
  <mat-label>Select View</mat-label>
  <mat-select
    [value]="activeType()"
    (selectionChange)="typeSelected.emit($event.value)"
  >
    @for (filter of typeFilters; track filter.value) {
      <mat-option [value]="filter.value">
        <span [textContent]="filter.label"></span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
